import { useRef } from 'react'
import { debounce } from 'lodash-es'

const useDebounce = (func: (...args: any) => any, waitTime = 400) => {
  return useRef(debounce(func, waitTime)).current
}

export default useDebounce
